import { render, staticRenderFns } from "./notifications-detail.vue?vue&type=template&id=7f2e5672&scoped=true"
import script from "./notifications-detail.vue?vue&type=script&lang=js"
export * from "./notifications-detail.vue?vue&type=script&lang=js"
import style0 from "./notifications-detail.vue?vue&type=style&index=0&id=7f2e5672&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e5672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2e5672')) {
      api.createRecord('7f2e5672', component.options)
    } else {
      api.reload('7f2e5672', component.options)
    }
    module.hot.accept("./notifications-detail.vue?vue&type=template&id=7f2e5672&scoped=true", function () {
      api.rerender('7f2e5672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/no-need-authorities/notifications-detail.vue"
export default component.exports